var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"capture"},[_c('app-blocks-common-form',{attrs:{"item":_vm.item,"endpoint":_vm.endpoint,"params":_vm.params},on:{"saved":_vm.onSaved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }